var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("./troy-logo.png"),"alt":"troy logo","srcset":"","width":_vm.size}})])
}
var staticRenderFns = []

export { render, staticRenderFns }